import { httpGet } from './apiService';

export abstract class TaggedSlugEntityPublicApiService<TaggedSlugEntityPreview> {
    protected readonly baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async getById(id: number): Promise<TaggedSlugEntityPreview | undefined> {
        const response = await httpGet(`${this.baseUrl}/id/${id}`);

        return response.json();
    }
}
